// https://kb.ertelecom.ru/pages/viewpage.action?pageId=195003438#:~:text=%D1%81%D0%BF%D0%B8%D1%81%D0%BA%D0%B0%20%D0%B4%D0%BB%D1%8F%20%D0%BE%D1%82%D0%BF%D1%80%D0%B0%D0%B2%D0%BA%D0%B8-,%D0%9F%D0%BE%D0%BB%D1%83%D1%87%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%BF%D0%B8%D1%81%D0%BA%D0%B0%20%D0%B4%D0%BE%D0%B3%D0%BE%D0%B2%D0%BE%D1%80%D0%BE%D0%B2%20%D0%BF%D0%BE%20%D0%BA%D0%BE%D0%BD%D1%82%D0%B0%D0%BA%D1%82%D1%83%20%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0%2C%20%D0%BF%D0%BE%D0%BB%D1%83%D1%87%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%BF%D0%B8%D1%81%D0%BA%D0%B0%20%D0%BA%D0%BE%D0%BD%D1%82%D0%B0%D0%BA%D1%82%D0%BE%D0%B2%20%D0%BF%D0%BE%20%D0%BD%D0%BE%D0%BC%D0%B5%D1%80%D1%83%20%D0%B4%D0%BE%D0%B3%D0%BE%D0%B2%D0%BE%D1%80%D0%B0,-%D0%9F%D0%B0%D1%80%D0%B0%D0%BC%D0%B5%D1%82%D1%80%3A%C2%A0get_agr_list_contact%20(%D0%B2%D1%8B%D0%B7%D0%BE%D0%B2
import { IRequest } from '@r1-frontend/shared/types/IRequest';


export type TModelsTypes = 'payment' | 'personal' | 'products' | 'contacts';

/**
 * Запрос информации о клиенте
 * https://master.api-profile.sandbox.d2c.r-one.io/docs/v2#/Info/app%5Cmodules%5Cv2%5Ccontrollers%5CInfoController%3A%3AactionAll
 */
export const getInfoAll = (
    providerId: number,
    accessToken: string,
    agreementNumber: string,
    models: TModelsTypes[] = ['personal', 'payment', 'products', 'contacts'],
): IRequest => ({
    uri: '/v2/info/all',
    method: 'GET',
    headers: {
        'ProviderId': `${providerId}`,
        'Authorization': `Bearer ${accessToken}`,
        agreementNumber,
    },
    queryParams: {
        models,
        floatRecSum: 1,
    },
});

